export default __webpack_public_path__ + "static/media/theme-bg.980c2bc8.svg";